export default "__VITE_ASSET__DhDrfe4t__"